'use client';

import { useState } from 'react';
import useVelocityAccountStore, {
	AccountData,
} from 'src/stores/useVelocityAccountsStore';
import useUiUpdateInterval from './useUiUpdateInterval';

/**
 * CAREFUL: This "actively" fetches sub accounts -> it will return a new value at an interval of `Env.uiEssentialUpdateIntervalMs`
 * @returns
 */
const useTickedAllSubAccounts = (): AccountData[] => {
	const getAccountsStore = useVelocityAccountStore((s) => s.get);
	const [accounts, setAccounts] = useState<AccountData[]>([]);

	useUiUpdateInterval(
		() => {
			setAccounts(
				Object.values(getAccountsStore().accounts).filter(
					Boolean
				) as AccountData[]
			);
		},
		true,
		false
	);

	return accounts;
};

export default useTickedAllSubAccounts;
